export enum StationType {
  front_camera = 'front_camera',
  rear_camera = 'rear_camera',
  external_scanner = 'external_scanner',
  user_defined = 'user_defined',
  maintenance = 'maintenance',
}

export enum StationExtraCategory {
  FOOD = 'FOOD',
  VISITOR_REGISTRATION = 'VISITOR_REGISTRATION',
  SELF_REGISTRATION = 'SELF_REGISTRATION',
}

export enum RequirementType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  FORM = 'FORM',
  /**
   * YB-2053 — a fields-only requirement. Every field maps to a real pass column and the value
   * the user submits is written onto their pass. Distinct from the ID-document variant, which
   * is IMAGE + identification_document = true.
   */
  SYSTEM_FIELDS = 'SYSTEM_FIELDS',
}

export enum RequirementStatus {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum RequirementsStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  NO_REQUIREMENTS = 'NO_REQUIREMENTS',
}

export enum ClientRoleLabelData {
  FULL_NAME = 'FULL_NAME',
  MOBILE = 'MOBILE',
  VALIDITY = 'VALIDITY',
  INVITED_BY = 'INVITED_BY',
}

export enum TimeInterval {
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  YEARS = 'YEARS',
}

export enum KpiReports {
  firstPassIssues = 'firstPassIssues',
  repeatedPassIssues = 'repeatedPassIssues',
  unauthenticBlocked = 'unauthenticBlocked',
}

export enum PassSecurityLevel {
  STANDARD = 0,
  LEVEL_1 = 1,
  LEVEL_2 = 2,
}

export enum Language {
  ENGLISH = 'english',
  HEBREW = 'hebrew',
  SPANISH = 'spanish',
}

export enum SessionDuration {
  FIVE_MINUTES = 5,
  FIFTEEN_MINUTES = 15,
  THIRTY_MINUTES = 30,
  TWO_HOURS = 120,
  FOUR_HOURS = 240,
}

export enum EntranceType {
  NONE = '',
}

export enum AreaType {
  NONE = '',
  VEHICLE = 'vehicle',
  HME = 'hme',
  // YB-2066: access is granted by a time-bounded booking, not by passes.areas membership
  BOOKABLE = 'bookable',
}
